export default class ImagePreview {
  constructor() {
    this.thumbnails = document.querySelectorAll('#product-thumbnails img');
    this.largeImage = document.querySelector('#product-preview img');

    this.addEvents();
  }

  addEvents() {
    [...this.thumbnails].map(img => {
      img.addEventListener('click', _ => this.setPreviewImage(img));
    });
  }

  setPreviewImage(thumbnail) {
    this.largeImage.setAttribute('src', thumbnail.getAttribute('data-large'));
  }
}